<template>
  <ListPage variant="page">
    <div class="tw-w-full tw-border-b tw-border-slate-200/60 tw-bg-white/50 tw-backdrop-blur-md tw-py-3 tw-px-4">
      <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-justify-between tw-gap-4">
        
        <div class="tw-flex-shrink-0">
          <div class="tw-flex tw-items-center tw-gap-2">
            <h1 class="tw-text-xl tw-font-bold tw-tracking-tight tw-text-slate-800">Dispatch</h1>
            <span class="tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-emerald-700">
              Live
            </span>
          </div>
          <div class="tw-text-xs tw-text-slate-500">Manage trips and containers</div>
        </div>

        <div class="tw-flex tw-items-center tw-gap-1.5 tw-bg-slate-100/50 tw-p-1 tw-rounded-xl">
          <button
            v-for="tab in ['container', 'trips', 'appointments']"
            :key="tab"
            type="button"
            class="tw-px-4 tw-py-1.5 tw-text-xs tw-font-semibold tw-rounded-lg tw-transition-all"
            :class="currentView === tab
              ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
              : 'tw-text-slate-500 hover:tw-text-slate-700'"
            @click="selectDispatchTab(tab)"
          >
            {{ tab.charAt(0).toUpperCase() + tab.slice(1) }}
          </button>
        </div>

      </div>
    </div>

    <div class="tw-mt-0">
      <dispatch-container-view v-if="currentView == 'container'"></dispatch-container-view>
      <daily-dispatch :isShowingAppointments="false" v-else-if="currentView == 'trips'"></daily-dispatch>
      <daily-dispatch :isShowingAppointments="true" v-else-if="currentView == 'appointments'"></daily-dispatch>
    </div>
  </ListPage>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ListPage from '@/components/core/ListPage.vue';
import DispatchContainerView from './DispatchContainerView.vue';
import DailyDispatch from './DailyDispatch.vue';

export default defineComponent({
  components: {
    ListPage,
    DispatchContainerView,
    DailyDispatch,
  },
  data(): any {
    return {
      // trips
      currentView: 'container',
      //   isAddingTrip: false,
    };
  },
  methods: {
    selectDispatchTab(tab: string) {
      (this as any).currentView = tab;
    },
  },
});
</script>
